import { BprRejectPopupData, BprRejectNotificationContext, VesselRouteSelectionModelBase } from "./vessel-route-selection-model";
import { VesselRouteSelectionNotification } from "../services/types/vessel-notifications-services.types";
import { VesselNotificationsService } from "../services/vessel-notifications-service";
import { isWithinBprReasonWindow } from "../utils/helpers";

export class VesselRouteSelectionModelImpl extends VesselRouteSelectionModelBase {
  constructor() {
    super();
  }

  private _scheduleId: string | null = null;
  private _lastBprRejectPopupData: BprRejectPopupData | undefined = undefined;
  private _departureTerminalCode: string | null = null;
  private _arrivalTerminalCode: string | null = null;
  private _planId: number | null = null;
  private _eta?: string | number = "";
  private _etd?: string | number = "";
  private _bprRankIDs: string[] = [];
  
  // The reason for not choosing a Star Route is collected until one day after ETD (never after ETA): vessels
  // often plan the route before departure but approve and send the plan shortly after departure.
  private isWithinReasonWindow(): boolean {
      const etd = this._etd;
      const eta = this._eta;
      if (!etd || !eta) {
          console.error('ETD or ETA is not set, cannot determine if the BPR reject reason is collected for schedule_id', this._scheduleId);
          return false;
      }

      // log warning if etd/eta is string so it can be visible in grafana, as they are expected to be numbers
      if (typeof etd === 'string' || typeof eta === 'string') {
          console.warn('ETD or ETA is a string, expected to be a number. Attempting to parse it to a timestamp, for schedule_id and imo', {
              etd: etd, eta: eta, scheduleId: this._scheduleId
          });
      }
      return isWithinBprReasonWindow(etd, eta);
  }

  async createVesselRouteSelectionNotification({reason, comment, navWarningNo}: VesselRouteSelectionNotification) {
    if (!this.isWithinReasonWindow()) {
      console.log("BPR Reject Notification will not be created more than a day after the etd or after the eta");
      return;
    }
    await VesselNotificationsService.createRouteSelectNotification(this._scheduleId ?? '',this._departureTerminalCode ?? '', this._arrivalTerminalCode ?? '', this._planId ?? 0, {reason, comment,navWarningNo},this._eta ?? "", this._etd ?? "", this._bprRankIDs);
    this._lastBprRejectPopupData = { reason: reason ?? '', comment: comment ?? '' };
  }

  getLastBprRejectPopupData(): BprRejectPopupData | undefined {
    return this._lastBprRejectPopupData;
  }

  getNotificationContext(): BprRejectNotificationContext {
    return {
      scheduleId: this._scheduleId,
      departureTerminalCode: this._departureTerminalCode,
      arrivalTerminalCode: this._arrivalTerminalCode,
      planId: this._planId,
      eta: this._eta,
      etd: this._etd,
      bprRankIDs: this._bprRankIDs,
    };
  }

  clearLastBprRejectPopupData(): void {
    this._lastBprRejectPopupData = undefined;
  }

  setPopupVisability(scheduleId: string, departureTerminal: string, arrivalTerminal: string, plansId: number, eta?: string|number, etd?: string|number, bprRankIDs?: string[]) {
    this._scheduleId = scheduleId;
    this._departureTerminalCode = departureTerminal;
    this._arrivalTerminalCode = arrivalTerminal;
    this._planId = plansId;
    this._eta = eta;
    this._etd = etd; 
    this._bprRankIDs = bprRankIDs || [];
    // prevent creating notification more than a day after the etd or after the eta
    if (!this.isWithinReasonWindow()) {
      console.log("BPR Reject Notification will not be created more than a day after the etd or after the eta");
      return;
    }
    this.dispatchEvent(new CustomEvent('popup-visible', {detail: { show: true, plansId }}));
  }
  
  setNotificationData(scheduleId: string, departureTerminal: string, arrivalTerminal: string, plansId: number, eta?: string|number, etd?: string|number, bprRankIDs?: string[]) {
    this._scheduleId = scheduleId;
    this._departureTerminalCode = departureTerminal;
    this._arrivalTerminalCode = arrivalTerminal;
    this._planId = plansId;
    this._eta = eta;
    this._etd = etd; 
    this._bprRankIDs = bprRankIDs || [];
  }
}
